/*
 * apex-prenatal.js
 * Apexzen prenatal LTV opt-in (etape 2-3-4).
 * Standalone handler for the optional due-date form shown on the quiz
 * waitlist result screen, but ONLY for the waitlist_prenat persona.
 * apex-quiz.js calls window.apxPrenatalInit(email, firstName) once, after it
 * reveals the waitlist result, when persona === 'waitlist_prenat'.
 *
 * Flow: due date + explicit health consent -> POST prenatal-optin edge
 * function -> double opt-in email -> user clicks link -> prenatal-confirm sets
 * consent. Nothing is stored long-term until that click.
 *
 * Kept OUT of apex-quiz.js on purpose (separate concern, separate lane).
 * ASCII only. No emoji. No em-dash.
 * Version 1.0.0 - 2026-06-09
 */
(function () {
  'use strict';

  var ENDPOINT = 'https://xhjhwmpzzygzudpkpjlh.supabase.co/functions/v1/prenatal-optin';
  var booted = false;

  function injectStyles() {
    if (document.getElementById('apx-prenatal-styles')) return;
    var css =
      '.apx-prenatal{margin-top:28px;text-align:left}' +
      '.apx-prenatal__divider{height:1px;background:rgba(26,46,85,.12);margin:0 0 22px}' +
      '.apx-prenatal__lead{margin:0 0 18px}' +
      '.apx-prenatal__field{margin-bottom:14px}' +
      '.apx-prenatal__label{display:block;margin-bottom:6px;font-weight:600}' +
      '.apx-prenatal__input{width:100%;max-width:260px;padding:12px 14px;border:1px solid rgba(26,46,85,.25);' +
      'border-radius:8px;font-size:15px;color:#1a2e55;background:#fff;box-sizing:border-box}' +
      '.apx-prenatal__input:focus{outline:none;border-color:#1a2e55;box-shadow:0 0 0 3px rgba(26,46,85,.12)}' +
      '.apx-prenatal__hp{position:absolute;left:-9999px;width:1px;height:1px;overflow:hidden}' +
      '.apx-prenatal__consent{margin:16px 0 18px}' +
      '.apx-prenatal__consent-label{display:flex;gap:10px;align-items:flex-start;cursor:pointer}' +
      '.apx-prenatal__consent-label input{margin-top:3px;flex:0 0 auto}' +
      '.apx-prenatal__submit{position:relative}' +
      '.apx-prenatal__submit[disabled]{opacity:.6;cursor:default}' +
      '.apx-prenatal__error{color:#b3261e;margin-top:12px}' +
      '.apx-prenatal__done{margin:8px 0 0}';
    var s = document.createElement('style');
    s.id = 'apx-prenatal-styles';
    s.textContent = css;
    document.head.appendChild(s);
  }

  var EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

  function showError(errEl, msg) {
    if (!errEl) return;
    errEl.textContent = msg;
    errEl.hidden = false;
  }

  function init(email, firstName) {
    if (booted) return;
    var wrap = document.getElementById('apx-prenatal-optin');
    var form = document.getElementById('apx-prenatal-form');
    if (!wrap || !form) return;
    booted = true;

    injectStyles();
    wrap.hidden = false;

    var dueInput = document.getElementById('apx-prenatal-due');
    var consentInput = document.getElementById('apx-prenatal-consent');
    var submit = document.getElementById('apx-prenatal-submit');
    var label = submit ? submit.querySelector('.apx-prenatal__submit-label') : null;
    var spinner = submit ? submit.querySelector('.apx-prenatal__submit-spinner') : null;
    var errEl = document.getElementById('apx-prenatal-error');
    var doneEl = document.getElementById('apx-prenatal-done');
    var hp = form.querySelector('input[name="website"]');

    // Floor the date picker to today so a past date cannot be chosen.
    if (dueInput) {
      try {
        dueInput.min = new Date().toISOString().slice(0, 10);
      } catch (e) { /* noop */ }
    }

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      if (errEl) errEl.hidden = true;

      var due = dueInput ? dueInput.value : '';
      if (!due) {
        showError(errEl, 'Please pick your due date, or skip this step.');
        return;
      }
      if (!consentInput || !consentInput.checked) {
        showError(errEl, 'Please tick the box so we are allowed to store your due date.');
        return;
      }
      if (!EMAIL_RE.test(String(email || ''))) {
        showError(errEl, 'We could not read your email. Please refresh and try again.');
        return;
      }

      if (submit) submit.disabled = true;
      if (label) label.textContent = 'Sending';
      if (spinner) spinner.hidden = false;

      var payload = {
        email: email,
        first_name: firstName || null,
        due_date: due,
        consent_health: true,
        website: hp ? hp.value : ''
      };

      fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) { return r.json().catch(function () { return {}; }); })
        .then(function (res) {
          if (res && (res.status === 'ok' || res.status === 'already_confirmed')) {
            form.hidden = true;
            if (doneEl) doneEl.hidden = false;
            if (window.apxTrack) {
              window.apxTrack('prenatal_optin_submitted', { status: res.status });
            }
          } else {
            if (submit) submit.disabled = false;
            if (label) label.textContent = 'Keep me posted after birth';
            if (spinner) spinner.hidden = true;
            showError(errEl, 'Something went wrong. Please try again in a moment.');
          }
        })
        .catch(function () {
          if (submit) submit.disabled = false;
          if (label) label.textContent = 'Keep me posted after birth';
          if (spinner) spinner.hidden = true;
          showError(errEl, 'Network error. Please try again in a moment.');
        });
    });
  }

  window.apxPrenatalInit = init;
})();
